import { render } from "./CreateGroupSurveyEmailSettings.vue?vue&type=template&id=732dc2d9&scoped=true"
import script from "./CreateGroupSurveyEmailSettings.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyEmailSettings.vue?vue&type=script&lang=js"

import "./CreateGroupSurveyEmailSettings.vue?vue&type=style&index=0&id=732dc2d9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732dc2d9"]])

export default __exports__